import { isAfter, isBefore, endOfDay, startOfDay, parseISO } from 'date-fns';

export async function referralDateCheck(
  referralDate: string,
  referralExpirationDate: string,
  dateOfService: string | Date
) {
  const dosOutOfRange = [
    `The Date of Service entered (${dateOfService}) in this notification is not within the valid date range of the authorization.`,
    'To request a new authorization or additional services please utilize the Request for Services(RFS) process',
    'and/or reach out to the referring Department of Veterans Affairs Medical Center(VAMC) for assistance.',
  ].join(' ');

  const dateOfServiceCheck = new Date(dateOfService);
  if (!referralDate || !referralExpirationDate) {
    return {
      error: dosOutOfRange,
    };
  }
  const isExpired = isAfter(
    dateOfServiceCheck,
    endOfDay(parseISO(referralExpirationDate))
  );
  const isBeforeReferralDate = isBefore(
    dateOfServiceCheck,
    startOfDay(parseISO(referralDate))
  );

  if (isExpired || isBeforeReferralDate) {
    return {
      error: dosOutOfRange,
    };
  }
}
